
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCollisionAvoidanceStarboardSide as ObiCollisionAvoidanceStarboardSideElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-collision-avoidance-starboard-side.js';
 
 
 

 
 export const ObiCollisionAvoidanceStarboardSide = createComponent({
   react: React,
   tagName: 'obi-collision-avoidance-starboard-side',
   elementClass: ObiCollisionAvoidanceStarboardSideElement,
   events: {
     
   }
  });
 
 